import { loadPlayerState, savePlayerState, type PlayerState } from "./playerStateRepository";

export const STARTER_HOARD_VERSION = 1;

type HoardCell = Record<string, unknown>;

const blankCell = (): HoardCell => ({
  terrain: null,
  material: null,
  climb: null,
  interactive: null,
  marker: null,
  buildZone: null,
  deviceUid: null,
  deviceNo: null,
  deviceName: "",
  simpleChannel: null,
  logicMode: "advanced",
  triggerBehavior: "toggle",
  sequence: [],
});

export function createSimpleStarterHoardMap(): HoardCell[][] {
  const map = Array.from({ length: 30 }, () =>
    Array.from({ length: 20 }, blankCell),
  );
  const platform = (x: number, y: number) => {
    map[y][x].terrain = "platform";
  };
  for (let x = 0; x < 20; x += 1) {
    platform(x, 0);
    platform(x, 28);
    platform(x, 29);
  }
  for (let y = 1; y < 28; y += 1) {
    platform(0, y);
    platform(19, y);
  }
  map[27][3].marker = "start";
  return map;
}

export function createStarterHoardState(): PlayerState {
  const homeMap = createSimpleStarterHoardMap();
  return {
    hero: "boy",
    gold: 0,
    vaultGold: 0,
    homeDecor: [
      {
        uid: "starter_workbench_v1",
        id: "workbench",
        x: 6,
        y: 27,
        roomId: "room_main",
      },
      {
        uid: "starter_vault_chest_v1",
        id: "vault_chest",
        x: 14,
        y: 27,
        roomId: "room_main",
      },
    ],
    homeGoldPiles: [],
    pendingGoldRain: null,
    completedMaps: {},
    earnedTrophies: [],
    homeMap,
    homeRooms: {
      room_main: {
        id: "room_main",
        name: "Main Room",
        theme: "depot",
        map: JSON.parse(JSON.stringify(homeMap)),
        topAligned: true,
      },
    },
    activeHomeRoom: "room_main",
    testGoldSeeded: false,
    homeTopAligned: true,
    hoardStarterVersion: STARTER_HOARD_VERSION,
    characterCustomization: {
      owned: [],
      ownedColorways: [],
      equipped: {},
      colorways: {},
    },
  };
}

/** Existing Hoards are never modified here; production migrations are explicit. */
export async function ensureStarterPlayerState(userId: string): Promise<PlayerState> {
  const existing = await loadPlayerState(userId);
  if (existing) return existing;
  const starter = createStarterHoardState();
  await savePlayerState(userId, starter);
  return starter;
}
